function showLoginPage() {
  //DisplayStatusMessage("Loging in to Aerosim Online Training", true);

  $('#RegisterPage').hide();
  $('#ForgotPasswordPage').hide();
  $('#LoginPage').show();

  $('#login-validation').hide();
  $('#forgotUsername').val("");
  $('#forgotEmail').val("");
}
window.showLoginPage = showLoginPage;

function showRegisterPage() {
  //DisplayStatusMessage("Registering Serial Number", true);

  $('#RegisterPage').show();
  $('#ForgotPasswordPage').hide();
  $('#LoginPage').hide();
}
window.showRegisterPage = showRegisterPage;

function showForgotPasswordPage() {
  //DisplayStatusMessage("User information will be sent to the email address listed in our database.", true);

  $('#RegisterPage').hide();
  $('#ForgotPasswordPage').show();
  $('#LoginPage').hide();

  $('#login-validation').hide();
}
window.showForgotPasswordPage = showForgotPasswordPage;

function clickedLogin() {
  DisplayStatusMessage("Logging in to the Learning Management System.", true);
  // Need to store credentials in sessionStorage so they can be used 
  //sessionStorage.setItem('flexPassthroughUN', $("#LoginUserName").val());
  //sessionStorage.setItem('flexPassthroughPW', $("#LoginPassword").val());
}
window.clickedLogin = clickedLogin;

function clickedRegister() {
  if ($("#RegisterForm").valid()) {
    DisplayStatusMessage("Registering serial number.", true);
  }
}
window.clickedRegister = clickedRegister;

function clickedChangePassword() {
  if ($("#ChangePasswordForm").valid()) {
    DisplayStatusMessage("Changing Password.", true);
  } else {

  }
}
window.clickedChangePassword = clickedChangePassword;

$(function () {
  $('#forgotPasswordForm').submit(function () {
    var data = $(this).serialize()
      $.ajax({
          url: this.action,
          type: this.method,
          data: data,
          success: function (result) {
              // The AJAX call succeeded and the server returned a JSON 
              // with a property "s" => we can use this property
              // and set the html of the target div
              //$('#ShowResultHere').html(result.s);
              DisplayStatusMessage("If the data you entered is valid you will receive an email shortly with your LMS account information.", true, "Request Sent", true);
              showLoginPage();
          },
          error: function (error, textStatus, errorThrown) {
              if(error.status == 429)
                  DisplayStatusMessage("Too many requests.  Please wait 60 seconds before attempting a Password Reset again.", true, "Error", true);
              else
                  DisplayStatusMessage("There was an issue creating a Password Reset Request.  Please try again or contact your training administrator.", true, "Error", true);
              showLoginPage();
          }
    });
    // it is important to return false in order to 
    // cancel the default submission of the form
    // and perform the AJAX call
    //DisplayStatusMessage("If the data you entered is valid you will receive an email shortly with your Aerosim account information.", true, "Request Sent", true);
    //showLoginPage();

    return false;
  });
});

// Bizarrely, this function does nothing, the jQuery crap above is what runs after SUBMIT is clicked
// on the forgot password view. -bep 2017 08 18 
function submitForgotPassword() {
  //DisplayStatusMessage("If the data you entered is valid you will recieve an email shortly with your Aerosim account information.", true, "Request Sent", true);
  //showLoginPage();
}
window.submitForgotPassword = submitForgotPassword;

/*
$(function () {
    $('#passwordResetForm').submit(function () {
        DisplayStatusMessage("Resetting Password", true, "Request Sent", true);

        $.ajax({
            url: this.action,
            type: this.method,
            data: $(this).serialize(),
            success: function (result) {
                // The AJAX call succeeded and the server returned a JSON 
                // with a property "s" => we can use this property
                // and set the html of the target div
                //$('#ShowResultHere').html(result.s);
            }
        });
        // it is important to return false in order to 
        // cancel the default submission of the form
        // and perform the AJAX call
        return false;
    });
});
*/

function DisplayStatusMessage(sMessage, bDisplay, sTitle, bShowButton) {
  if (bDisplay) {
    // display status message (sMessage)
    // Set modal text
    $('.modal-body').text(sMessage);
    $('#myModal').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#myModal').modal('show');

    if (bShowButton)
      $('#modalDismissButton').show();
    else
      $('#modalDismissButton').hide();

    if (sTitle) {
      var div = $('#myModalLabel')[0].firstChild;
      div.nodeValue = sTitle;
    }
    else {
      var div = $('#myModalLabel')[0].firstChild;
      div.nodeValue = "Please Wait";
    }

  }
  else {
    // hide status message
    $('#myModal').modal('hide');
  }
}
window.DisplayStatusMessage = DisplayStatusMessage;

function setDisplayMessageText(sMessage) {
  $('.modal-body').text(sMessage);
}
window.setDisplayMessageText = setDisplayMessageText;

function clearErrorMessage(entity) { entity.errorMessage(null); }
window.clearErrorMessage = clearErrorMessage;

function ajaxRequest(type, url, data, dataType) { // Ajax helper
  var sendData = data ? data.toJson ? data.toJson() : data : null;

  var options = {
    dataType: dataType || "json",
    contentType: "application/json",
    cache: false,
    type: type,
    data: sendData
  };

  var antiForgeryToken = $('input[name="__RequestVerificationToken"]').val();
  if (antiForgeryToken) {
    options.data.__RequestVerificationToken = antiForgeryToken;
  }
  return $.ajax(url, options);
}
window.ajaxRequest = ajaxRequest;

// routes
function forgotPasswordUrl(id) { return lcms.baseUrl + "Account/ForgotPassword" + (id || ""); }



// WEBPACK FOOTER //
// ./Content/js/login/login.js